import React from 'react';
import { Download, Monitor, Apple, Terminal } from 'lucide-react';
import SpaceBackground from '../components/layout/SpaceBackground';

const Downloads = () => {
  const downloads = [
    {
      name: 'macOS (Apple Silicon)',
      file: 'Virgo_1.0.0_aarch64.dmg',
      icon: Apple,
      description: 'For Mac computers with M1, M2, M3, or M4 chips',
      size: '13 MB',
    },
    {
      name: 'Linux (Debian/Ubuntu)',
      file: 'Virgo_1.0.0_amd64.deb',
      icon: Terminal,
      description: 'For Debian, Ubuntu, and derivatives',
      size: '13 MB',
    },
    {
      name: 'Linux (Fedora/RHEL)',
      file: 'Virgo-1.0.0-1.x86_64.rpm',
      icon: Terminal,
      description: 'For Fedora, Red Hat, CentOS, and derivatives',
      size: '13 MB',
    },
    {
      name: 'Linux (AppImage)',
      file: 'Virgo_1.0.0_amd64.AppImage',
      icon: Terminal,
      description: 'Universal Linux package - runs on any distribution',
      size: '82 MB',
    },
  ];

  return (
    <SpaceBackground>
      <div className="min-h-screen p-6">
        <div className="max-w-4xl mx-auto">
          <div className="flex items-center gap-3 mb-8">
            <Monitor className="w-8 h-8 text-virgo-purple-400" />
            <h1 className="text-2xl font-bold text-white">Desktop App Downloads</h1>
          </div>

          <p className="text-gray-300 mb-8">
            Download the Virgo desktop app for your operating system. The desktop app provides 
            offline access, system notifications, and enhanced performance.
          </p>

          <div className="grid gap-4">
            {downloads.map((download) => {
              const Icon = download.icon;
              return (
                <a
                  key={download.file}
                  href={`/downloads/${download.file}`}
                  className="flex items-center gap-4 p-4 bg-slate-800/50 backdrop-blur border border-slate-700 rounded-xl hover:border-virgo-purple-400 transition-colors group"
                >
                  <div className="p-3 bg-virgo-purple-500/20 rounded-lg">
                    <Icon className="w-6 h-6 text-virgo-purple-400" />
                  </div>
                  <div className="flex-1">
                    <h3 className="font-semibold text-white group-hover:text-virgo-purple-300 transition-colors">
                      {download.name}
                    </h3>
                    <p className="text-sm text-gray-400">{download.description}</p>
                  </div>
                  <div className="text-right">
                    <div className="flex items-center gap-2 text-virgo-teal-400">
                      <Download className="w-5 h-5" />
                      <span className="font-medium">Download</span>
                    </div>
                    <span className="text-xs text-gray-500">{download.size}</span>
                  </div>
                </a>
              );
            })}
          </div>

          <div className="mt-8 p-4 bg-amber-500/10 border border-amber-500/30 rounded-lg">
            <h3 className="font-semibold text-amber-400 mb-2">macOS Installation Note</h3>
            <p className="text-sm text-gray-300">
              Since the app isn't signed with an Apple Developer certificate, macOS may show a security warning. 
              To open the app, right-click (or Control-click) on Virgo.app and select "Open" from the menu, 
              then click "Open" in the dialog.
            </p>
          </div>

          <div className="mt-4 text-center text-sm text-gray-500">
            Version 1.0.0
          </div>
        </div>
      </div>
    </SpaceBackground>
  );
};

export default Downloads;
